<template>    
    <BaseModal
        :id="'static-rooms-cleaned-by-room-type'"
        :title="'Rooms Cleaned by Room Type '"
        :message="'This is a list showing the total number of rooms left to clean and the total number already cleaned, grouped by room type.'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div v-if="loading" class="text-center w-100" style="height: 3rem !important;">
                <div class="spinner-border mt-2" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="tab-content mt-4" v-if="rooms_cleaned_by_room_type.length">
                <div class="tab-pane fade active show" id="listation">
                    <div class="row mb-0 no-gutters">
                        <div class="col-lg-12">
                            <v-card>
                                <DinamicTable
                                    :headers="table_headers"
                                    :items="rooms_cleaned_by_room_type"
                                    :search="''"
                                    :size="30"
                                />
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!rooms_cleaned_by_room_type.length && !loading" class="alert alert-warning" role="alert">
                No records available
            </div>
            <CentralLiteButtons :done="true"/>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import DinamicTable from '@/components/DinamicTable'
import BaseModal from '@/components/BaseModal'
import CentralLiteButtons from '@/components/CentralLiteButtons';

export default {

    name:   'RoomsCleanedByRoomTypeModal',
    props: [
        "rest_api",
        "breadcrumb",
    ],

    components:{
        CentralLiteButtons,
        Breadcrumb,
        BaseModal,
        DinamicTable
    },

    data(){
        return {
            rooms_cleaned_by_room_type: [],
            loading: true,
            table_headers: [
                {
                    text:   "Room Type",
                    value:  "description",
                },
                {
                    text:   "Rooms cleaned",
                    value:  "rooms_cleaned"
                },
                {
                    text:   "Rooms left to clean",
                    value:  "rooms_left_to_clean"
                },
            ]
        }
    },

    methods:{
        async getRoomsCleanedByRoomType()
        {
            this.rooms_cleaned_by_room_type = []
            this.loading = true
            const response = await this.get(`${this.rest_api}/rooms_cleaned_by_room_type`)
            this.loading = false

            if(response.status)
            {
                this.rooms_cleaned_by_room_type = response.data.data
                let sum = 0
                this.rooms_cleaned_by_room_type.forEach(item => {
                    sum += item.rooms_left_to_clean
                })
                console.log(sum);
            }
            else
            {
                this.error_handling(response)
            }

        },
    },

    mounted(){

    }
    
}
</script>